import { backOffCall } from 'api/api.js'
import { API_URL, BE_VERSION } from 'config/constants'
import master from 'store/master'
import i18n from 'config/i18n'

const getAll = () => {

  const query = () => {
    return fetch(`${API_URL}/services`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept-Language': i18n.language,
        'Accept-Version': BE_VERSION,
      }
    })
  }

  return backOffCall(query)
}

const getPopular = () => {
  const query = () => {
    return fetch(`${API_URL}/services/popular`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept-Language': i18n.language,
        'Authorization': master.token,
        'Accept-Version': BE_VERSION,
      }
    })
  }

  return backOffCall(query)
}

export {
  getAll,
  getPopular
}
